import * as z from "zod/v4";

export const discardOptimizationJobDrafts = {
  name: "discardOptimizationJobDrafts" as const,
  input: z.object({ jobId: z.bigint() }),
  output: z.void(),
};
